import { Translate } from 'react-redux-i18n'
import { formatText } from '../../../../../../helpers/value'
import { TITLE_TABLE_ADD_COMPANY } from '../../../constant'
import { TdActionTableAddCompany } from './TdActionTableAddCompany'

export const getSchemaTableAddCompany = () =>
  TITLE_TABLE_ADD_COMPANY.map((item, index) => {
    const result = {
      title: <Translate value={item.label} />,
      colId: item.key,
      thStyle: {
        textAlign: 'left',
        textTransform: 'capitalize  ',
      },
      tdStyle: {
        textAlign: 'left',
      },
    }
    if (index === 0) {
      return {
        ...result,
        render: (val, { rowIndex }) => {
          return rowIndex + 1
        },
      }
    }
    if (index === 3) {
      return {
        ...result,
        render: (val, { rowId }) => <TdActionTableAddCompany rowId={rowId} />,
      }
    }
    return {
      ...result,
      render: (val) => {
        return formatText(val)
      },
    }
  })
